import CustomReportTemplateIcon from "../../components/SVGComponents/CustomReportTemplateIcon";
import { ControlAndSettingsIcon } from "../../components/SVGComponents/ControlAndSettingsIcon";
import { YourReportsIcon } from "../../components/SVGComponents/YourReportsIcon";
import { SELECTED_TAB_KEY } from "../../constants/Constants";
import CustomToolTipHost from "../../components/CustomToolTipHost/CustomToolTipHost";
import { Icon } from "@fluentui/react";

export const breadCrumbItems = [
  {
    text: "AI Requests",
    key: "masters",
  },
];

export const aiResultsInitialState = {
  destination: [],
  patientId: null,
  patientName: null,
  jobId: null,
  sendingStatus: null,
  responseStatus: null,
  createdDateFrom: null,
  createdDateTo: null,
  clientNames: [],
};

export const searchStyle = {
  root: {
    background: "transparent",
    border: "1px solid rgba(200, 198, 196, 0.3)",
    borderRadius: "5px",
  },
};

export const iconButtonStyles = {
  icon: { color: "#0078d4", border: "none", outline: "none" },
  root: {
    backgroundColor: "transparent",
    // selectors: {
    //   ':hover .ms-Button-icon': {
    //     color: '#0078d4'
    //   },
    // },
    width: "20px",
    height: "20px",
    margin: "2px",
  },
  rootHovered: { backgroundColor: "transparent" },
  rootPressed: { backgroundColor: "transparent" },
};

export const cancelIconButtonStyles = {
  icon: { color: "red", border: "none", outline: "none" },
  root: {
    backgroundColor: "transparent",
    width: "20px",
    height: "20px",
    margin: "2px",
  },
  rootHovered: { backgroundColor: "transparent" },
  rootPressed: { backgroundColor: "transparent" },
};

export const sendingStatusOptions = [
  { key: '0', text: 'SCHEDULED' },
  { key: '1', text: 'BATCH CREATED' },
  { key: '2', text: 'PROCESSING' },
  { key: '3', text: 'COMPLETED' },
  { key: '4', text: 'COMPLETED WITH ERRORS' },
  { key: '5', text: 'CLOSED' }
];

export const responseStatusOptions = [
  { key: '1', text: 'WAITING' },
  { key: '2', text: 'RECEIVED' },
  { key: '3', text: 'CLOSED' }
];

export const STATUS_BADGE = {
  SENDING: {
    SCHEDULED: { BG: '#555', TXT: '#E2E3E5', SHORT: 'SCHEDULED', FULL: 'SCHEDULED' },
    BATCH_CREATED: { BG: '#8A6D00', TXT: '#FFF3CD', SHORT: 'BATCH CREATED', FULL: 'BATCH CREATED' },
    PROCESSING: { BG: '#A25B00', TXT: '#FFE5CC', SHORT: 'PROCESSING', FULL: 'PROCESSING' },
    COMPLETED: { BG: '#155724', TXT: '#D4EDDA', SHORT: 'COMPLETED', FULL: 'COMPLETED' },
    ERROR: { BG: '#1B5E20', TXT: '#E8F5E9', SHORT: <>COMPLETED <span style={{ color: '#FFD700', marginLeft: '5px' }}>!</span></>, FULL: 'COMPLETED WITH ERRORS' },
    CLOSED: { BG: '#721C24', TXT: '#F8D7DA', SHORT: 'CLOSED', FULL: 'CLOSED' },
    UNKNOWN: { BG: '#555', TXT: '#E0E0E0', SHORT: 'UNKNOWN', FULL: 'UNKNOWN' }
  },

  RESPONSE: {
    WAITING: { BG: '#8A6D00', TXT: '#FFF3CD', SHORT: 'WAITING', FULL: 'WAITING' },
    RECEIVED: { BG: '#155724', TXT: '#D4EDDA', SHORT: 'RECEIVED', FULL: 'RECEIVED' },
    CLOSED: { BG: '#721C24', TXT: '#F8D7DA', SHORT: 'CLOSED', FULL: 'CLOSED' }
  }
};

export const getSendingStatusBadge = (status) => {
  let cfg;

  switch (status) {
    case 0: cfg = STATUS_BADGE.SENDING.SCHEDULED; break;
    case 1: cfg = STATUS_BADGE.SENDING.BATCH_CREATED; break;
    case 2: cfg = STATUS_BADGE.SENDING.PROCESSING; break;
    case 3: cfg = STATUS_BADGE.SENDING.COMPLETED; break;
    case 4: cfg = STATUS_BADGE.SENDING.ERROR; break;
    case 5: cfg = STATUS_BADGE.SENDING.CLOSED; break;
    default: cfg = STATUS_BADGE.SENDING.UNKNOWN;
  }

  return (
    <CustomToolTipHost content={cfg.FULL}>
      <span
        className="study-list-report-details-text"
        style={{
          backgroundColor: cfg.BG,
          color: cfg.TXT,
          padding: "2px 6px",
          borderRadius: "6px",
          fontSize: "12px",
          whiteSpace: "nowrap",
          display: "inline-flex",      
          alignItems: "center",       
          height: "18px",
          marginTop: 0,
        }}
      >
        {cfg.SHORT}
      </span>
    </CustomToolTipHost>
  );
};

export const getResponseStatusBadge = (status) => {
  if (status === 0) return <span className="study-list-report-details-text" style={{marginTop: 0}}>-</span>;

  let cfg;

  switch (status) {
    case 1: cfg = STATUS_BADGE.RESPONSE.WAITING; break;
    case 2: cfg = STATUS_BADGE.RESPONSE.RECEIVED; break;
    case 3: cfg = STATUS_BADGE.RESPONSE.CLOSED; break;
  }

  return (
    <CustomToolTipHost content={cfg.FULL}>
      <span
        className="study-list-report-details-text"
        style={{
          backgroundColor: cfg.BG,
          color: cfg.TXT,
          padding: "2px 6px",
          borderRadius: "6px",
          fontSize: "12px",
          whiteSpace: "nowrap",
          display: "inline-flex",      
          alignItems: "center", 
          height: "18px",
          marginTop: 0,
        }}
      >
        {cfg.SHORT}
      </span>
    </CustomToolTipHost>
  );
};
